module.exports = __webpack_public_path__ + "img/Deathknight-draenei-m-70.8e1eafa9.gif";